import { z } from 'zod';

const EnvSchema = z.object({
  VITE_KANBAN_API_URL: z.string().default('http://localhost:3002'),
  VITE_ACCOUNTS_API_URL: z.string().default('http://localhost:4001'),
  VITE_CONVERSATION_API_URL: z.string().default('http://localhost:5002'),
  VITE_MICE_API_URL: z.string().default('http://localhost:4060'),
  VITE_COGNITO_AUTHORITY: z.string().optional(),
  VITE_COGNITO_CLIENT_ID: z.string().optional(),
  VITE_COGNITO_IDENTITY_PROVIDER: z.string().optional(),
  // Base URL of the Zendesk instance — used to deep-link a card's linked
  // handoff ticket (externalRefs[system='zendesk']) to its agent ticket page.
  VITE_ZENDESK_URL: z.string().default('https://newvoll.zendesk.com'),
  // Base URL of the web-chat (traveler app) framed by "Ver como viajante".
  // Optional: absent or empty turns the page into a "not configured" notice.
  VITE_WEB_CHAT_URL: z
    .string()
    .optional()
    .transform((v) => (v === '' ? undefined : v)),
  DEV: z.boolean().default(false),
});

export type Env = z.infer<typeof EnvSchema>;

function loadEnv(): Env {
  const parsed = EnvSchema.safeParse(import.meta.env);
  if (!parsed.success) {
    const issues = parsed.error.issues
      .map((i) => `  - ${i.path.join('.')}: ${i.message}`)
      .join('\n');
    throw new Error(`Invalid VITE_* environment variables:\n${issues}`);
  }
  return parsed.data;
}

export const env: Env = loadEnv();
